import RootRequest from "./RootRequest";

export interface AnafCompany {
  tin: string;
  name: string;
  address: string;
  phone: string;
  registrationNumber: string;
  vatPayer: boolean;
  isActive: boolean;
  county: County | null;
  city: City | null;
}

export default class AnafApiRequest extends RootRequest {
  get apiResource() {
    return "api/anaf-api";
  }

  get apiRoutes(): Record<string, string> {
    return {
      // @ts-ignore
      ...super.apiRoutes,
      GET_COMPANY: `${this.apiRoute}/company/`,
    };
  }

  async getCompanyByCui(cui: string): Promise<AnafCompany> {
    const response = await this.makeRequest(
      RootRequest.METHOD.GET,
      this.apiRoutes.GET_COMPANY + encodeURIComponent(cui)
    );

    return response?.data;
  }
}

export const anafApiRequest = new AnafApiRequest();

export interface AnafInfo {
  vatPayer: boolean;
  isActive: boolean;
}

export function anafInfoText(info: AnafInfo): string {
  const vat = info.vatPayer ? "Plătitor de TVA" : "Neplătitor de TVA";
  const active = info.isActive ? "Firmă activă" : "Firmă inactivă";
  return `Date preluate de la ANAF • ${vat} • ${active}`;
}

export function anafInfoColor(info: AnafInfo): string {
  if (!info.isActive) {
    return "warning.main";
  }
  return info.vatPayer ? "success.main" : "text.secondary";
}

export function anafErrorMessage(status?: number): string {
  switch (status) {
    case 400:
      return "CUI invalid.";
    case 404:
      return "Nu s-au găsit date pentru acest CUI.";
    case 503:
      return "Serviciul ANAF nu este disponibil momentan.";
    default:
      return "Nu s-au putut prelua datele de la ANAF.";
  }
}
